import moment from 'moment';
import { getStorageValue } from './localStorageState';

// const weekDays = {
//     Monday:"Ponedjeljak",
//     Tuesday:"Utorak",
//     Wednesday:"Srijeda",
//     Thursday:"Četvrtak",
//     Friday:"Petak",
//     Saturday:"Subota",
//     Sunday:"Nedjelja",
// }


const monthsName:any = {
    January: "siječnja",
    February: "veljače",
    March: "ožujka",
    April: "travnja",
    May: "svibnja",
    June: "lipnja",
    July: "srpnja",
    August: "kolovoza",
    September: "rujna",
    October: "listopada",
    November: "studenog",
    December: "prosinca",
}

const parseDate = (momentDate:any) => {
    const month = momentDate.format("MMMM")
    const langCode = getStorageValue("language", "hr");


    return momentDate.format("D. ") + (langCode === "hr" ? monthsName[month] : month) + momentDate.format(" YYYY.")
}
export const getDate = (date: string)=> parseDate(moment(date))

export const getDateFromMilliSeconds = (milliSeconds: string)=> parseDate(moment(Number(milliSeconds)*1000))
